require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-indiana-latino-expo.json") })
        }
      }, "path---articles-tags-indiana-latino-expo");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-indiana-latino-expo!./.cache/json/articles-tags-indiana-latino-expo.json
// module id = 1816
// module chunks = 231608221292675